import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Modal from 'components/common/Modal'
import Text from 'components/common/Text/Text'
import Media from 'components/common/Media'
import isAuthorized from 'helpers/check-authorization'
import {
  StoreContactsLineA,
  StoreContactsLineText,
  StoreOwnerInfo
} from '../../StoreDetailsPage/components/StoreInformation/components'
import CreateAccountLink from '../CreateAccountLink/CreateAccountLink'
import DurationInfo from 'components/QuickAppointmentPage/Stepper/components/DurationInfo'

const AppointmentSuccessModal = ({
  message,
  navigateHome,
  registrationLocation,
  storeAddress,
  locationPhoneNumberFormatted,
  locationPhoneNumberUrl,
  owner,
  handlePhoneLinkClick
}) =>
  <CustomModal title="Approval Pending" closeHandler={ navigateHome }>
    <Text lineheight={ 1.5 }>{ message }</Text>
    <ShopDetailsBlock>
      <StoreOwnerInfo owner={ owner } address={ storeAddress } locallyOwnedImage />
      <StoreContactBlock>
        {
          storeAddress.phoneNumber && (storeAddress.phoneNumber.firstThree != null) &&
          <React.Fragment>
            <Media.Desktop>
              <StoreContactsLineText data-at-store-phone asset={ 'phone' } value={ locationPhoneNumberFormatted } />
            </Media.Desktop>
            <Media.Mobile>
              <StoreContactsLineA
                target="_self"
                asset={ 'phone' }
                value={ locationPhoneNumberFormatted }
                url={ locationPhoneNumberUrl }
                onClick={ handlePhoneLinkClick } />
            </Media.Mobile>
          </React.Fragment>
        }
        {
          owner && owner.email &&
          <StoreContactsLineA data-at-store-email asset={ 'email-blue' } value={ owner.email } url={ `mailto:${owner.email}` } target="_self" />
        }
      </StoreContactBlock>
    </ShopDetailsBlock>

    { !isAuthorized() && <CreateAccountLink registrationLocation={ registrationLocation } /> }

    <DurationDisclaimer />
  </CustomModal>

export default AppointmentSuccessModal

AppointmentSuccessModal.propTypes = {
  handlePhoneLinkClick: PropTypes.func,
  locationPhoneNumberFormatted: PropTypes.string,
  locationPhoneNumberUrl: PropTypes.string,
  message: PropTypes.string,
  navigateHome: PropTypes.func,
  owner: PropTypes.shape(),
  registrationLocation: PropTypes.shape(),
  storeAddress: PropTypes.shape()
}

const CustomModal = styled(Modal)`
  ${Media.desktop`
    padding: 37px 18px 67px 24px;
  `}
`

const ShopDetailsBlock = styled.div`
  &:last-child {
    border: 0;
  }

  margin: 25px 0;
  ${Media.desktop`
    display: block;
    vertical-align: middle;
  `}
`

const StoreContactBlock = styled.div`
  padding: 20px 0;
  ${Media.mobile`
    padding-bottom: 0;
  `}
`

const DurationDisclaimer = styled(DurationInfo)`
  margin-left: 18px;
`
